export const environment = {
  production: false,
  tenant: {
    id: 'ndt-dev',
    name: 'PPS (DEV)'
  },
  externalCrm: true,
  rest: {
    apiUrl: 'pps-dev.ndt-division.de',
    protocol: 'https',
    port: 443,
    basePath: '/v1',
    uploadBaseUrl: ''
  },
  auth: {
    apiUrl: 'pps-dev.ndt-division.de',
    protocol: 'https',
    port: 443
  },
  crm: {
    apiUrl: 'pps-dev.ndt-division.de/crmapi',
    protocol: 'https',
    port: 443
  },
  versions: {
    npm: '9.6.7',
    node: 'v18.17.1 (LTS)',
    clarity: '17.6'
  },
  stages: {
    name: "  DEV STAGE!",
    dev: true,
  }
};
